import { useEffect, useState } from 'react';

import { Helmet as Helm } from 'react-helmet';

import { pageTitleAndDescription } from '../../utils/constants';

export default function Helmet() {
  const [titleAndDescription, setTitleAndDescription] = useState(pageTitleAndDescription[0]);
  useEffect(() => {
    const updatedTitleAndDescription = pageTitleAndDescription.find((ele) =>
      ele.url.includes(location.pathname)
    );
    if (updatedTitleAndDescription) {
      setTitleAndDescription({ ...updatedTitleAndDescription });
    }
  }, [location.pathname]);

  return (
    <Helm>
      <title>{titleAndDescription.title}</title>
      {titleAndDescription.description && (
        <meta name="description" content={titleAndDescription.description} />
      )}
    </Helm>
  );
}
